import {Comparator, Predicate} from "../../../types/GenericTypes";
import {OptionExpiry} from "./OptionExpiry";

export class OptionExpiryUtil {

    public static naturalOrdering(): Comparator<OptionExpiry> {
        return (a, b) => a.date.localeCompare(b.date);
    }

    public static equals(value: OptionExpiry): Predicate<OptionExpiry>;
    public static equals(value: OptionExpiry, other: OptionExpiry): boolean;

    public static equals(value: OptionExpiry, other?: OptionExpiry): any {

        if (other != null) {
            return this.areEqual(value, other);
        } else {
            return (o: OptionExpiry) => this.areEqual(value, o);
        }
    }

    private static areEqual(value: OptionExpiry, other: OptionExpiry): boolean {
        return (other.date === value.date) && (other.expiryType === value.expiryType);
    }
}
